import { Button } from "@/components/ui/button";
import { Headset, Brain, Radar, Shield, LineChart, Users, ArrowRight, Activity } from "lucide-react";

const pillars = [
  { i: Users, t: "Acompanhamento humano", d: "Squad sênior dedicado, presente nas decisões críticas da campanha." },
  { i: Headset, t: "Suporte estratégico", d: "Consultoria contínua sobre roteiros, segmentações e prioridades." },
  { i: Activity, t: "Monitoramento operacional", d: "Performance, entregabilidade e estabilidade auditadas em tempo real." },
  { i: Shield, t: "Gestão anti-ban", d: "Arquitetura multi-sessão e camadas de proteção operacional." },
  { i: LineChart, t: "Otimização contínua", d: "Ajustes recorrentes baseados em comportamento real da base." },
  { i: Brain, t: "Inteligência aplicada", d: "IA, análise territorial e leituras estratégicas integradas à operação." },
];

export function ServicePremiumSection() {
  return (
    <section id="service" className="py-24 bg-primary text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-25" />
      <div className="absolute -top-40 -right-20 h-[500px] w-[500px] rounded-full bg-accent/30 blur-3xl" />
      <div className="absolute -bottom-40 -left-20 h-[500px] w-[500px] rounded-full bg-success/15 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-6">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/20 text-highlight text-xs font-semibold uppercase tracking-wider">
              <Radar className="h-3.5 w-3.5" /> VoxCampaign Service
            </div>
            <h2 className="mt-4 text-4xl sm:text-5xl font-bold leading-tight">
              Mais do que tecnologia.{" "}
              <span className="text-highlight">Uma operação estratégica.</span>
            </h2>
            <p className="mt-5 text-lg text-primary-foreground/80">
              O Vox Service é uma <strong className="text-highlight">central de comando político</strong>: nossa equipe opera junto com a sua campanha, sustentando comunicação, decisão e estabilidade em todas as fases do calendário eleitoral.
            </p>

            <div className="mt-8 rounded-2xl bg-white/5 border border-white/10 backdrop-blur p-6">
              <div className="text-xs font-bold uppercase tracking-wider text-highlight mb-3">A sensação certa</div>
              <p className="text-xl font-semibold leading-snug">
                "Uma central de comando político operando ao lado da sua campanha — todos os dias."
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <Button asChild size="lg" className="bg-highlight text-highlight-foreground hover:opacity-95 h-12 px-7 text-base font-bold shadow-glow">
                <a href="https://wa.me/5561982415240?text=Ol%C3%A1%2C%20quero%20conhecer%20o%20Vox%20Service." target="_blank" rel="noopener">
                  Falar com especialista <ArrowRight className="ml-1 h-4 w-4" />
                </a>
              </Button>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {pillars.map((p) => (
              <div key={p.t} className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur p-6 hover:bg-white/10 transition-colors">
                <div className="h-11 w-11 rounded-xl bg-highlight/15 flex items-center justify-center mb-4">
                  <p.i className="h-5 w-5 text-highlight" />
                </div>
                <h3 className="font-bold">{p.t}</h3>
                <p className="text-sm text-primary-foreground/70 mt-1.5">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
